import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Anchor, Box, Button, Heading, Menu, ResponsiveContext, Tab, Tabs, Text, TextInput, Image } from "grommet";
import * as React from "react";
import { Link, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { usePermission, useUser } from "../account/AccountStore";
import CustomButton from "../components/CustomButton";
import LinkAnchor from "../components/LinkAnchor";
import StyledModal from "../components/StyledModel";
import CreateMap from "./CreateMap";
import { MapCard } from "./MapCard";
import MapProfile from "./MapProfile";
import { getMaps, MapViewModel } from "./MapsStore";
import { formatRelative, parseJSON } from "date-fns";
import { orderBy } from "lodash";

const plus = <FontAwesomeIcon icon={["fad", "plus"]}></FontAwesomeIcon>;
// @ts-ignore
const bulkPlus = <FontAwesomeIcon size="xl" icon={["fad", "layer-plus"]}></FontAwesomeIcon>;
// @ts-ignore
const mapPlus = <FontAwesomeIcon size="xl" icon={["fad", "users-medical"]}></FontAwesomeIcon>;
const edit = <FontAwesomeIcon icon={["fad", "pencil"]}></FontAwesomeIcon>;
const idBadge = <FontAwesomeIcon icon={["fad", "id-badge"]}></FontAwesomeIcon>;
const search = <FontAwesomeIcon icon={["fad", "search"]}></FontAwesomeIcon>;

const MapsManagement = () => {
    const user = useUser();

    const [maps, setMaps] = React.useState([] as MapViewModel[]);
    const [filter, setFilter] = React.useState("");
    const [filteredMaps, setFilteredMaps] = React.useState([] as MapViewModel[]);
    let { pathname } = useLocation();

    React.useEffect(() => {
        getMaps(user.organization.id).then((maps) => {
            setMaps(maps);
        });
    }, [pathname, user]);

    React.useEffect(() => {
        if (filter) {
            setFilteredMaps(
                orderBy(
                    maps.filter((t) => t.name.toLowerCase().indexOf(filter.toLowerCase()) != -1),
                    ["name"],
                    ["asc"]
                )
            );
        } else {
            setFilteredMaps(orderBy(maps, ["name"], ["asc"]));
        }
    }, [maps, filter]);

    const [showMapInfo, setShowMapInfo] = React.useState(false);
    const [selectedMap, setSelectedMap] = React.useState({} as MapViewModel);

    const selectMap = (map: MapViewModel) => {
        setSelectedMap(map);
        setShowMapInfo(true);
    };

    return (
        <div>
            <Box direction="row" gap="small" justify="between">
                <Box direction="row" justify="end" gap="small" align="center">
                    <Box pad="small">
                        <TextInput icon={search} placeholder="Search..." value={filter} onChange={(e) => setFilter(e.target.value)}></TextInput>
                    </Box>
                </Box>
            </Box>
            <Box direction="row" gap="medium" wrap justify="center">
                {filteredMaps.map((map) => (
                    <Box margin={{ bottom: "medium" }} key={map.id} onClick={() => selectMap(map)}>
                        <MapCard map={map}></MapCard>
                    </Box>
                ))}
            </Box>
            <Box pad={{ top: "small" }}>
                {maps.length != filteredMaps.length && (
                    <Text>
                        Showing {filteredMaps.length} of {maps.length}{" "}
                        <Anchor href="#" onClick={() => setFilter("")}>
                            Show All
                        </Anchor>
                    </Text>
                )}
            </Box>
            <StyledModal isOpen={showMapInfo} setIsOpen={() => setShowMapInfo(false)}>
                {selectedMap && (
                    <Box>
                        <Heading level={3}>{selectedMap.name}</Heading>
                        {selectedMap.logoUri && <Image src={selectedMap.logoUri} width={600}></Image>}
                        <Box pad={"small"}>
                            <Text>{selectedMap.description}</Text>
                            <Text>
                                <FontAwesomeIcon icon={["fad", "download"]}></FontAwesomeIcon> {selectedMap.downloads} Downloads
                            </Text>
                            {selectedMap.createdDate && <Text size="small">{formatRelative(parseJSON(selectedMap.createdDate), new Date())}</Text>}
                        </Box>

                        <Box direction="row">{selectedMap.contentUri && <Button href={selectedMap.contentUri} download label="Download Map"></Button>}</Box>
                    </Box>
                )}
            </StyledModal>
        </div>
    );
};

export default MapsManagement;
